var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6l8 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6l4 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12l2 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12l10 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18l11 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18l1 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.d724f98db9e2c72617c7b79f430b4ddb.svg";
export { ForwardRef as ReactComponent };